import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';

@Component({
  selector: 'textarea-questiontype',
  templateUrl: './textarea.questiontype.component.html'
})
export class TextareaQuestiontypeComponent implements OnInit, OnDestroy {
  @Input() required:boolean;
  @Input() prompt:string;
  @Input() tooltip:string;
  @Input() questionid:number;
  @Input() disabled:boolean;
  @Input() questioninitmixin:any;
  value:'';
  formSegment:FormGroup;

  public getValue():object {
    var result={};
    if(!this.disabled) {
      result[this.questionid]=this.formSegment.value['item'];
    } else {
      result[this.questionid]=null;
    }
    return result;
  }

  isValid():boolean {
    if(this.disabled) {
      return true;
    }
    return !this.formSegment.controls['item'].errors;
  }
  validate():boolean {
    this.formSegment.controls['item'].markAsTouched();
    return this.isValid();
  }

  get formError():string {
    var err;

    if((this.formSegment.controls['item'].dirty || this.formSegment.controls['item'].touched) && !this.isValid()) {
      err=this.formSegment.controls['item'].errors;
      if(!!err.required) {
        return 'This answer is required.';
      }
      if(!!err.minlength) {
        return 'This answer must be at least '+err.minlength.requiredLength+' characters. You have entered '+err.minlength.actualLength+'.';
      }
      if(!!err.maxlength) {
        return 'This answer may be no longer than '+err.maxlength.requiredLength+' characters. You have entered '+err.maxlength.actualLength+'.';
      }
      if(!!err.pattern) {
        return 'This answer does not match the required pattern.';
      }
    }
    return '';
  }

  ngOnInit() {
    var init={};
    var validators=[];
    if (this.required) {
      validators.push(Validators.required);
    }
    if(!!this.questioninitmixin) {
      if(!!this.questioninitmixin['minLength']) {
        validators.push(Validators.minLength(this.questioninitmixin['minLength']));
      }
      if(!!this.questioninitmixin['maxLength']) {
        validators.push(Validators.min(this.questioninitmixin['maxLength']));
      }
      if(!!this.questioninitmixin['email']) {
        validators.push(Validators.email);
      }
      if(!!this.questioninitmixin['pattern']) {
        validators.push(Validators.pattern(this.questioninitmixin['pattern']));
      }
    }
    init['item']=new FormControl(this.value);

    this.formSegment=new FormGroup(init);
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/questionnaire/elements/textarea.questiontype.component.ts